import script from "./modal_editfile.vue?vue&type=script&setup=true&lang=ts"
export * from "./modal_editfile.vue?vue&type=script&setup=true&lang=ts"

import "./modal_editfile.vue?vue&type=style&index=0&id=40c8bddc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c8bddc"]])

export default __exports__